import { useEffect } from 'react';

let locks = 0;
let originalOverflow = '';

export function useBodyScrollLock(isLocked: boolean) {
  useEffect(() => {
    if (!isLocked) return;

    if (locks === 0) originalOverflow = document.body.style.overflow;
    locks += 1;
    document.body.style.overflow = 'hidden';

    return () => {
      locks -= 1;
      if (locks === 0) document.body.style.overflow = originalOverflow;
    };
  }, [isLocked]);
}
